import { CustomProperties } from '../types';
import { track } from '../utils';

export function trackStatusChanged(
  Studio: string,
  name: string,
  category: string,
  includedNote: boolean,
) {
  track('Asset Status Changed', {
    Studio,
    'Status Name': name,
    'Status Category': category,
    'Included note': includedNote,
  });
}

export function trackAssetDeleted(
  productName: string,
  modelNumber: string,
  manufacturerName: string,
  assetId: string,
) {
  track('Asset Deleted', {
    'Product Model #': modelNumber,
    'Product Name': productName,
    'Manufacturer Name': manufacturerName,
    'Asset Id': assetId,
  });
}

const $8KB_LIMIT = 200;
export function trackAssetsDeleted(
  productNames: string[],
  productModelNumbers: string[],
  manufacturerNames: string[],
  assetIds: string[],
) {
  track('Asset Bulk Delete', {
    'Product Names': productNames,
    'Product Model #s': productModelNumbers,
    'Manufacturer Names': manufacturerNames,
    '# of Assets': assetIds.length,
    'Asset Ids': assetIds.slice(0, $8KB_LIMIT),
  });
}

export function trackAssetEdited(
  productModelNumber: string | undefined,
  manufacturerName: string | undefined,
  Parameter: string,
  assetId: string,
  productName: string | undefined,
  type: CustomProperties['Field Type'],
) {
  track('Asset Edited', {
    'Product Name': productName,
    'Product Model #': productModelNumber,
    'Manufacturer Name': manufacturerName,
    Parameter,
    'Asset Id': assetId,
    'Field Type': type,
  });
}

export function trackAssetsEdited(Parameters: string[], assetIds: string[]) {
  // Majority of properties were excluded, simply because they also change.

  track('Asset Bulk Edit', {
    Parameters: Parameters.slice(0, $8KB_LIMIT),
    '# of Assets': assetIds.length,
    'Asset Ids': assetIds.slice(0, $8KB_LIMIT),
  });
}
